import { Common, color } from '@stockbit/ui';
import Image from 'global/Image';

const { Button, Flex, Text, Modal } = Common;

interface ShariaUnavailableProps {
  visible: boolean;
  onClose: () => void;
}

function ShariaUnavailableModal({ visible, onClose }: ShariaUnavailableProps) {
  const handleClick = () => {
    if (onClose) onClose();
  };

  return (
    <Modal visible={visible} centered width="500px" onCancel={handleClick}>
      <Flex direction="column" align="center" padding="50px 30px 20px">
        <Image src="/images/syariah/unavailable.svg" alt="Unavailable" />

        <Text align="center" family="bold" size="16px" my="16px">
          Bukan Saham Syariah
        </Text>
        <Text align="center" color={color.dimgray}>
          Kamu tidak bisa bertransaksi saham non-syariah.
        </Text>
        <Text align="center" family="bold">
          (Fatwa No.80/DSN-MUI/III/2011)
        </Text>

        <Flex justify="center" style={{ width: '100%' }} mt="40px">
          <Button
            type="primary"
            radius="4px"
            block
            height="40px"
            width="200px"
            onClick={handleClick}
          >
            <Text align="inherit" color="white" family="bold" size="16px">
              Oke
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default ShariaUnavailableModal;
